export default {"src":"/_next/static/media/circle-line-solid.b1a11fd8.svg","height":16,"width":16};